import { BackgroundStylesInterface } from 'common/types/background-interfaces'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CloseButton, SecondaryButton } from 'src/editor/shared/ui-lib/buttons'
import { Trash02Icon } from '../../icons/trash-02-icon'
import { BackgroundPosition } from './background-position'

interface ImageSettingsPanelProps {
  isLecture?: boolean
  title?: string
  deleteBtnText?: string
  selectTitle?: string
  onClose: () => void
  onDelete: () => void
  backgroundPosition?: BackgroundStylesInterface
  onUpdateBackgroundPosition?: (value: BackgroundStylesInterface) => void
}

export const ImageSettingsPanel = (props: ImageSettingsPanelProps) => {
  const {
    title = 'components.core.settings.background_position.title',
    deleteBtnText = 'components.core.settings.background_position.delete_image',
    selectTitle = 'components.core.settings.background_position.display_image',
    onClose,
    onDelete,
    onUpdateBackgroundPosition,
    backgroundPosition,
    isLecture = false,
  } = props

  const { t } = useTranslation()
  const isBackgroundPosition =
    'backgroundPosition' in props &&
    'onUpdateBackgroundPosition' in props &&
    onUpdateBackgroundPosition

  return (
    <div className="relative w-[264px] max-w-[300px] rounded-lg border border-btnSecondaryBorder bg-bgPrimaryBase pt-1.5">
      <div className="flex items-center justify-between border-btnSecondaryBorder border-b p-1.5 px-4">
        <h5 className="text-heading-5"> {t(title)}</h5>
        <CloseButton onClick={onClose} />
      </div>

      <div className="p-4">
        {isBackgroundPosition && (
          <BackgroundPosition
            selectTitle={selectTitle}
            onUpdateBackgroundPosition={onUpdateBackgroundPosition}
            backgroundPosition={backgroundPosition}
            isLecture={isLecture}
          />
        )}

        <SecondaryButton
          iconBefore={<Trash02Icon />}
          className="w-full"
          onClick={onDelete}
        >
          {t(deleteBtnText)}
        </SecondaryButton>
      </div>
    </div>
  )
}
